import React, { useState, useEffect } from "react";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import Modal from "react-bootstrap/Modal";
import { SlOption, SlSelect, SlDrawer, SlButton, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import Button from "react-bootstrap/Button";
import { Form as selectForm } from "react-bootstrap";
import { useNavigate } from "react-router";
import * as Yup from "yup";
import { useFormik } from "formik";
import { capitalizeFirstLetter, roles, stateOptions } from "../../utils/constants";
import { Toast } from "../../shared/Toast";
import api from "../../services/api";
import { formatDateWithTime } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import Paginator from "../../shared/Paginator";
import { useDispatch, useSelector } from 'react-redux';
import config from "../../config";
import TableLoader from "../../shared/TableLoader";
import { debounce } from "../../utils/Debounce";
import CompanyDetails from "../Orders/CompanyDetails";
import PendingRequestModal from "../MakerChecker/components/PendingRequestModal";

const initialCompany = {
    company_name: "",
    billing_name: "",
    billing_mobile: "",
    billing_email: "",
    gst_no: "",
    pan_no: "",
    state_id: "",
    district_id: "",
    mandal_id: "",
    village_id: "",
    address: "",
    category_id: "",
    isagency: false,
    commission: 0,
    Account_number: "",
    Ifsc_code: "",
};


let initialValues = JSON.parse(JSON.stringify(initialCompany));

const CompanySchema = Yup.object().shape({
    // advertiserType: Yup.string().required("Advertiser Type is required"),
    company_name: Yup.string().required("Company Name is required"),
    billing_name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Advertiser name can't start with white space and should not contain special characters").required(" Name is required"),
    billing_mobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
        .min(10, "Mobile must be 10 digits")
        .max(10, "Mobile must be 10 digits")
        .required("Mobile Number is required"),
    billing_email: Yup.string().email().required("Email is required"),
    gst_no: Yup.string()
        .matches(
            /[0-9]{2}[A-Z]{5}[0-9]{4}[A-z][0-9][Z][0-9A-Z]/,
            "Invalid GST number - case sensitive "
        )
        .optional(),
    pan_no: Yup.string()
        .matches(/[A-Z]{5}[0-9]{4}[A-Z]/, "Invalid PAN number - case sensitive")
        .optional(),
    Account_number: Yup.string().matches(/[0-9]{9,18}/, "Account Number Invalid").optional(),
    Ifsc_code: Yup.string().matches(/[A-Z]{4}0[A-Z0-9]{6}/, "Invalid Ifsc Code").optional(),
    address: Yup.string().optional(),
    isagency: Yup.boolean(),
    commission: Yup.number().when("isagency", {
        is: (isagency) => isagency,
        then: Yup.number()
            .required("Commission is required")
            .min(1, "Must be greater than or equal to 1")
            .max(100, "Must be less than or equal to 100"),
    }).nullable(),
});

function Company() {
    const navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState(-1);
    const [agency, setAgency] = useState(-1);
    // const [itemOffset, setItemOffset] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const [flag, setFlag] = useState("");

    const [show, setShow] = useState(false);
    const [data, setData] = useState([]);
    // const [date, setDate] = useState('');
    const [open, setOpen] = useState(false);
    const [id, setId] = useState("");
    const [search, setSearch] = useState("");
    const [companyId, setCompanyId] = useState();
    const [showCompany, setShowCompany] = useState(false);
    const [refresh, setRefresh] = useState(false)
    const [logs, setLogs] = useState({})
    const [verified_status, setVerified_status] = useState(-1);
    const [initialRender, setInitialRender] = useState(true)



    const HeaderSearch = useSelector(state => state.Head.adssearch)

    function handleSales(items) {
        setOpen(true);
        loadSales();
    }
    const handle = () => {
        setOpen(false);
        setView(false);
        // setSub(false)
        setDisplay(false);
    };

    const [sales, setSales] = useState([]);
    const [sales_id, setSalesId] = useState(-1);
    const [category, setCategory] = useState([]);
    const [advtype, setAdvType] = useState("");
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [mandals, setMandals] = useState([]);
    const [villages, setVillages] = useState([]);
    const [submit, setSubmit] = useState(false);
    const [view, setView] = useState(false);
    const [types, setTypes] = useState([]);
    const [res, setRes] = useState({});
    const [display, setDisplay] = useState(false);

    const [selectedMcId, setSelectedMcId] = useState('');
    const handleCloseModal = () => {
        setSelectedMcId(null);
    };
    function handleLocation(item) {
        setDisplay(true);
        setRes(item);
    }

    const handlePageClick = (event) => {
        // const newOffset = (event.selected * config.PER_PAGE) % data.length;
        // setItemOffset(newOffset);
        setCurrentPage(event.selected);
        loadData(search, event.selected, status, agency, verified_status);
    };

    const handleClose = () => {
        initialValues = JSON.parse(JSON.stringify(initialCompany));
        formik.setValues(initialValues);
        setShow(false);
        setSubmit(false);
    };
    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    const loadData = async (searchString = "", page = 0, status = -1, agency = -1, verified_status= -1) => {
        try {
            setLoader(true);
            let res = await api({
                url: `/user/company/getCompanies`,
                method: "POST",
                responseType: "json",
                data: {
                    page: page,
                    limit: config.PER_PAGE,
                    search: searchString,
                    status: parseInt(status),
                    agency: parseInt(agency),
                    verified_status: parseInt(verified_status)
                },
            });
            setData(res.data.data.length ? res.data.data : []);
            setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
            setLoader(false);
        } catch (error) {
            if (error?.response?.status === 401) navigate("/");
        }
    };

    useEffect(() => {
        Header()
    }, [HeaderSearch])
    useEffect(() => {
        if(!initialRender)
            loadData(HeaderSearch, currentPage, status, agency, verified_status)
    },[refresh])

    const Header = () => {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        loadData(HeaderSearch, 0, status, agency, verified_status);
        setInitialRender(false)
    }

    const searchData = (e) => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0, status, agency, verified_status);
    };

    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialCompany)),
        validationSchema: CompanySchema,
        onSubmit: async (values) => {
            if (!values.isagency) values.commission = null;
            if (flag === "add") {
                try {
                    let res = await api({
                        url: `/user/company`,
                        method: "POST",
                        responseType: "json",
                        data: {...values,ref_table:"company"},
                    });
                    if (res?.data?.code === 500) {
                        Toast("error", res.data.message);
                    } else {
                        Toast("success", "Company Add Request Sent Successfully");
                        handleClose();
                        setCurrentPage(0);
                        setSearch("");
                        setStatus(-1);
                        setAgency(-1);
                        loadData(search, 0, status, agency, verified_status);
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong";
                    Toast("error", er);
                    if (error.response.status === 401) navigate("/");
                }
            }

            if (flag === "edit") {
                try {
                    values.id = id;
                    let res = await api({
                        url: `/user/company/${id}`,
                        method: "PUT",
                        responseType: "json",
                        data: {...values,ref_table:"company"},
                    });
                    if (res?.code === 200) {
                        Toast("success", "Company updated Successfully");
                        loadData(search, currentPage, status, agency, verified_status);
                        handleClose();
                        values = JSON.parse(JSON.stringify(initialCompany));
                    } else {
                        Toast("error", res?.data?.message);
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong";
                    Toast("error", er);
                    if (error.response.status === 401) navigate("/");
                }
            }
        },
    });

    const getStates = async () => {
        try {
            const response = await api({
                url: `/user/company/getstates`,
                method: "GET",
                responseType: "json",
            });
            if (response?.data?.data) {
                setStates(response?.data?.data);
            }
        } catch (error) {
            console.log("error");
        }
    };

    const getDistricts = async (state_id) => {
        try {
            let res = await api({
                url: `/user/company/getdistricts`,
                method: "POST",
                responseType: "json",
                data: { state_id },
            });
            if (res.code === 200) {
                setDistricts(res.data);
            }
        } catch (error) {
            if (error.response.status === 401) navigate("/");
        }
    };
    const getMandals = async (dist_id) => {
        try {
            let res = await api({
                url: `/user/company/getmandals`,
                method: "POST",
                responseType: "json",
                data: { dist_id },
            });
            if (res?.code === 200) {
                setMandals(res.data);
            }
        } catch (error) {
            if (error.response.status === 401) navigate("/");
        }
    };

    const getVillages = async (mandal_id) => {
        try {
            let res = await api({
                url: `/user/company/getvillages`,
                method: "POST",
                responseType: "json",
                data: { mandal_id },
            });
            if (res.code === 200) {
                setVillages(res.data);
            }
        } catch (error) {
            if (error.response.status === 401) navigate("/");
        }
    };

    const loadCategories = async () => {
        try {
            let res = await api({
                url: "/user/advertisers/campaign_categories",
                method: "GET",
                responseType: "json",
            });
            if (res?.data?.length) setCategory(res.data);
            else setCategory([]);
        } catch (error) {
            console.log(error);
            if (error.response.status === 401) navigate("/");
        }
    };

    const loadSales = async () => {
        try {
            let res = await api({
                url: "/user/sales_persons/getsales",
                method: "GET",
                responseType: "json",
            });
            setSales(res.data);
        } catch (error) {
            console.log(error);
            if (error.response.status === 401) navigate("/");
        }
    };

    const handleSalesSave = async () => {
        if (sales_id === -1) {
            Toast("error", " Please select salesperson to assign ");
        } else {
            try {
                await api({
                    url: `/user/company/sales/${id}`,
                    method: "PUT",
                    responseType: "json",
                    data: {
                        sales_person_id: parseInt(sales_id),
                    },
                });
                Toast("success", "Sales Person assigned Succesfully");
                handle();
                loadData(search, currentPage, status, agency, verified_status);
                setSalesId(-1);
            } catch (error) {
                let er = error?.response?.message || "Something went wrong";
                Toast("error", er);
                if (error.response.status === 401) navigate("/");
            }
        }
    };

    const handleShow = async (choose, item) => {
        if (choose === "add") {
            formik.setValues(item);
            setShow(true);
        }
        if (choose === "edit") {
            await loadCategories();
            initialValues.billing_name = item.billing_name;
            initialValues.billing_email = item.billing_email || "";
            initialValues.billing_mobile = item.billing_mobile;
            initialValues.gst_no = item.gst_no || "";
            initialValues.pan_no = item.pan_no || "";
            initialValues.company_name = item.company_name;
            initialValues.state_id = item.state_id ? String(item.state_id) : "";
            initialValues.Account_number = item.account_num || "";
            initialValues.Ifsc_code = item.ifsc || "";
            await getStates();
            initialValues.state_name = item.state_name || "";
            item.state_id && (await getDistricts(item.state_id));
            initialValues.district_id = item.district_id ? String(item.district_id) : "";
            initialValues.district_name = item.district_name || "";
            item.district_id && (await getMandals(item.district_id));
            initialValues.mandal_id = item.mandal_id ? String(item.mandal_id) : "";
            initialValues.mandal_name = item.mandal_name || "";
            item.mandal_id && (await getVillages(item.mandal_id));
            initialValues.village_id = item.village_id ? String(item.village_id) : "";
            initialValues.village_name = item.village_name || "";
            initialValues.address = item.address || "";
            initialValues.category_name = item.category_name;
            initialValues.category_id = item.category_id;
            // initialValues.isagency = item.isagency ? true : false;
            initialValues.isagency = item.isagency == 1
            initialValues.commission = item.commission || "";
            initialValues.status = item.status;
            formik.setValues(initialValues);
            setShow(true);
        }
    };

    const onInputChange = (type, id) => {
        switch (type) {
            case "state_id":
                formik.setFieldValue(
                    "state_name",
                    stateOptions.find((j) => j.state_id === +id)?.state_name
                );
                formik.setFieldValue("mandal_id", "");
                formik.setFieldValue("mandal_name", "");
                formik.setFieldValue("village_id", "");
                formik.setFieldValue("village_name", "");
                formik.setFieldValue("district_id", "");
                formik.setFieldValue("district_name", "");
                break;
            case "district_id":
                formik.setFieldValue(
                    "district_name",
                    districts.find((j) => j.dist_id === +id)?.dist_name
                );
                formik.setFieldValue("mandal_id", "");
                formik.setFieldValue("mandal_name", "");
                formik.setFieldValue("village_id", "");
                formik.setFieldValue("village_name", "");
                break;
            case "mandal_id":
                formik.setFieldValue(
                    "mandal_name",
                    mandals.find((j) => j.mandal_id === +id)?.mandal_name
                );
                formik.setFieldValue("village_id", "");
                formik.setFieldValue("village_name", "");
                break;
            case "village_id":
                formik.setFieldValue(
                    "village_name",
                    villages.find((j) => j.village_id === +id)?.village
                );
                break;
            default:
        }
    };

    // const deleteAdvertiser = async (id1) => {
    //     try {
    //         await api({
    //             url: `/user/advertisers/${id1}`,
    //             method: "DELETE",
    //             responseType: "json"
    //         });
    //         Toast('success', "Advertiser Deleted Successfully");
    //         setCurrentPage(0);
    //         setSearch('');
    //         setStatus(-1);
    //         setAgency(-1);
    //         loadData(search, 0, status, agency);
    //     } catch (error) {
    //         let er = error?.response?.message || "Something went wrong"
    //         Toast("error", er)
    //         if (error.response.status === 401)
    //             navigate("/")
    //     }
    // }

    // useEffect(() => {
    // const timer = setTimeout(() => {
    // loadData(search, 0, status, agency);
    // }, 200);

    // return () => clearTimeout(timer);
    // }, []);

    // useEffect(() => {
    //     setCategoryId(category_id)
    // }, [])

    // useEffect(() => {
    //     setStateId(state_id)
    // }, [])

    // useEffect(() => {
    //     setDistId(district_id)
    // }, [])

    // useEffect(() => {
    //     setMandalId(mandal_id)
    // }, [])

    // useEffect(() => {
    //     setVillageId(village_id)
    // }, [])

    // useEffect(() => {
    //     loadData();

    // }, [currentPage]);

    const handleAdv = () => {
        setAdvType("");
        setView(true);
    };
    const handleInputChange = (e) => {
        setAdvType(e.target.value);
    };
    const handleAdvType = async () => {
        const advregex = /^[A-Za-z0-9][A-Za-z0-9!@#$%^&*()_+-=<>?/|}{~:]*/
        if (advtype.match(advregex)) {
            try {
                let res = await api({
                    url: `/user/advertisers/addadvtype`,
                    method: "POST",
                    responseType: "json",
                    data: { advtype },
                });
                if (res?.data?.code === 500) {
                    Toast("error", res.data.message);
                    setAdvType("");
                } else {
                    Toast("success", "Company Type Added Successfully");
                    handle();
                    setView(false);
                    setAdvType("");
                }
            } catch (error) {
                let er = error?.response?.message || "Something went wrong";
                Toast("error", er);
                setAdvType("");
                if (error.response.status === 401) navigate("/");
            }
        }
        else {
            Toast("error", "Company Type can't start with special characters");
        }
    }

    const statusSearch = (e) => {
        setStatus(e.target.value);
        setCurrentPage(0);
        loadData(search, 0, e.target.value, agency, verified_status);
    };

    const agencySearch = (e) => {
        setAgency(e.target.value);
        setCurrentPage(0);
        loadData(search, 0, status, e.target.value, verified_status);
    };

    const getLogs = async(details) => {
        try {
            let res = await api({
                url: `/user/company/getLogs`,
                method: "POST",
                responseType: "json",
                data: { id : details.id },
            });
            if (res?.code === 200) {
                setLogs({company_name: details.company_name, logs: res.data})
            } else {
                Toast("error", res.data.message);
            }
        } catch (error) {
            console.error("Error @ getLogs", error)
        }
    }
    const verifiedSearch = (e) => {
        setVerified_status(e.target.value);
        setCurrentPage(0);
        loadData(search, 0, status, agency, e.target.value);
    };
    return (
        <div>
            <div className="flex items-center gap-3 mb-3">
                <aside className="ml-auto flex items-center gap-3 flex-wrap">
                    {/* <div className="w-60">
                        <SlInput type="text"
                            size="small"
                            id="myInput"
                            onSlInput={debounce(searchData, 500)}
                            placeholder="Search By Name / Email / Mobile / Type">
                            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                        </SlInput>
                    </div> */}

                    <div  className="w-40">
                        <SlSelect onSlChange={statusSearch} size="small" placeholder="Status">
                            <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
                            <SlOption value="-1">All </SlOption>
                            <SlOption value="1">Active </SlOption>
                            <SlOption value="0">Inactive </SlOption>
                        </SlSelect>
                    </div>
                    <div  className="w-40">
                        <SlSelect onSlChange={verifiedSearch} size="small" placeholder="Verified Status">
                            <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
                            <SlOption value="-1">All </SlOption>
                            <SlOption value="1">Verified </SlOption>
                            <SlOption value="2">Not Verified </SlOption>
                            <SlOption value="3">Rejected </SlOption>
                        </SlSelect>
                    </div>
                    <div  className="w-40">
                        <SlSelect placeholder="Agency" size="small" onSlChange={agencySearch}>
                            <SlIcon library="lucide" name="star" slot="prefix"></SlIcon>
                            <SlOption value="-1">All</SlOption>
                            <SlOption value="1">Agency</SlOption>
                        </SlSelect>
                        {/* <select
            name="agency"
            className="form-select"
            onChange={agencySearch}
          >
            <option value="-1" key="-1">
              All
            </option>
            <option value="1" key="1">
              Agency
            </option>
          </select> */}
                    </div>
                    <div className="w-40">
                        <SlButton variant="primary" size="small"  onClick={() => {
                            handleShow("add", {});
                            setFlag("add");
                            loadCategories();
                            getStates();
                        }}>Add Company</SlButton>
                    </div>
                </aside>
            </div>
            <SlDrawer label={flag === "edit" ? "Edit Company" : "Add Company"} open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ '--size': '640px' }}>

                <form onSubmit={formik.handleSubmit}>

                    {/* <div className="mb-3">
                        <div className="flex gap-4 items-center mb-3">
                            <label>Advertiser Type <span className="text-red-600">*</span></label>
                            <SlButton
                                size="small"
                                variant="primary"
                                outline
                                onClick={handleAdv}>Add New Type</SlButton>
                        </div>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="advertiserType"
                            placeholder="Select Advertiser Type"
                            onBlur={formik.handleBlur}
                            value={formik.values.advertiserType}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        >
                            <option value="">Select Type</option>
                            {types.map((item) => {
                                return (
                                    <option value={item.id} key={item.id}>
                                        {item.type}
                                    </option>
                                );
                            })}
                        </select>
                        {submit && formik.errors.advertiserType ? (
                            <div className="text-red-600	">
                                {formik.errors.advertiserType}
                            </div>
                        ) : null}
                    </div> */}


                    <div className="mb-3">
                        <label className="mb-1"> Company Name <span className="text-red-600">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Company Name"
                            aria-label=""
                            name="company_name"
                            value={formik.values.company_name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.company_name ? (
                            <div className="text-red-600	">{formik.errors.company_name}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="mb-1">
                            {" "}
                            Billing Person Name <span className="text-red-600">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Billing Person Name"
                            aria-label=""
                            name="billing_name"
                            value={formik.values.billing_name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.billing_name ? (
                            <div className="text-red-600	">
                                {formik.errors.billing_name}
                            </div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="mb-1">Billing Person Mobile No <span className="text-red-600">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Billing Person Mobile No"
                            aria-label=""
                            name="billing_mobile"
                            value={formik.values.billing_mobile}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.billing_mobile ? (
                            <div className="text-red-600	">{formik.errors.billing_mobile}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="mb-1"> Billing Person Email <span className="text-red-600">*</span></label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Enter Billing Person Email"
                            aria-label=""
                            name="billing_email"
                            value={formik.values.billing_email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.billing_email ? (
                            <div className="text-red-600	">{formik.errors.billing_email}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="mb-1">GST NO</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter GST No"
                            aria-label=""
                            name="gst_no"
                            value={formik.values.gst_no}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.gst_no ? (
                            <div className="text-red-600	">{formik.errors.gst_no}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="mb-1">Pan NO</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter PAN No"
                            aria-label=""
                            name="pan_no"
                            value={formik.values.pan_no}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.pan_no ? (
                            <div className="text-red-600	">{formik.errors.pan_no}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="mb-1"> Account Number </label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Account Number"
                            aria-label=""
                            name="Account_number"
                            value={formik.values.Account_number}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.Account_number ? (
                            <div className="text-red-600	">{formik.errors.Account_number}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="mb-1"> IFSC Code</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter IFSC code"
                            aria-label=""
                            name="Ifsc_code"
                            value={formik.values.Ifsc_code}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.Ifsc_code ? (
                            <div className="text-red-600	">{formik.errors.Ifsc_code}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="col-sm-2 col-form-label"> States </label>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="state_id"
                            placeholder="Select State"
                            onBlur={formik.handleBlur}
                            value={formik.values.state_id}
                            onChange={(e) => {
                                formik.handleChange(e);
                                getDistricts(e.target.value);
                                onInputChange("state_id", e.target.value);
                            }}
                        >
                            <option value="">Select State</option>
                            {states.map((item) => {
                                return (
                                    <option value={item.state_id} key={item.state_id}>
                                        {item.state_name}
                                    </option>
                                );
                            })}
                        </select>
                        {submit && formik.errors.state_id ? (
                            <div className="text-red-600	">{formik.errors.state_id}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="col-sm-2 col-form-label"> Districts </label>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="district_id"
                            placeholder="Select Ditrict"
                            onBlur={formik.handleBlur}
                            value={formik.values.district_id}
                            onChange={(e) => {
                                formik.handleChange(e);
                                getMandals(e.target.value);
                                onInputChange("district_id", e.target.value);
                            }}
                        >
                            <option value="">Select District</option>
                            {districts.map((item) => {
                                return (
                                    <option value={item.dist_id} key={item.dist_id}>
                                        {item.dist_name}
                                    </option>
                                );
                            })}
                        </select>
                        {submit && formik.errors.district_id ? (
                            <div className="text-red-600	">{formik.errors.district_id}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="col-sm-2 col-form-label"> Mandals </label>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="mandal_id"
                            placeholder="Select Mandal"
                            onBlur={formik.handleBlur}
                            value={formik.values.mandal_id}
                            onChange={(e) => {
                                formik.handleChange(e);
                                getVillages(e.target.value);
                                onInputChange("mandal_id", e.target.value);
                            }}
                        >
                            <option value="">Select Mandal</option>
                            {mandals.map((item) => {
                                return (
                                    <option value={item.mandal_id} key={item.mandal_id}>
                                        {item.mandal_name}
                                    </option>
                                );
                            })}
                        </select>
                        {submit && formik.errors.mandal_id ? (
                            <div className="text-red-600	">{formik.errors.mandal_id}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="col-sm-2 col-form-label"> Villages </label>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="village_id"
                            placeholder="Select Village"
                            onBlur={formik.handleBlur}
                            value={formik.values.village_id}
                            onChange={(e) => {
                                formik.handleChange(e);
                                onInputChange("village_id", e.target.value);
                            }}
                        >
                            <option value="">Select Village</option>
                            {villages.map((item) => {
                                return (
                                    <option value={item.village_id} key={item.village_id}>
                                        {item.village}
                                    </option>
                                );
                            })}
                        </select>
                        {submit && formik.errors.village_id ? (
                            <div className="text-red-600	">{formik.errors.village_id}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label className="mb-1">Address</label>
                        <input
                            type="textarea"
                            className="form-control"
                            placeholder="Enter Address"
                            aria-label=""
                            name="address"
                            value={formik.values.address}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.address ? (
                            <div className="text-red-600	">{formik.errors.address}</div>
                        ) : null}
                    </div>
                    {/* <div className="mb-3">
                        <label className="col-sm-2 col-form-label"> category</label>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="category_id"
                            placeholder="Select Category"
                            onBlur={formik.handleBlur}
                            value={formik.values.category_id}
                            onChange={(e) => {
                                formik.handleChange(e);
                                onInputChange("category_id", e.target.value);
                            }}
                        >
                            <option value="">Select Category</option>
                            {category.map((item) => {
                                return (
                                    <option value={item.category_id} key={item.category_id}>
                                        {item.category_name}
                                    </option>
                                );
                            })}
                        </select>
                        {submit && formik.errors.category_id ? (
                            <div className="text-red-600	">{formik.errors.category_id}</div>
                        ) : null}
                    </div> */}
                    <div className="mb-3 form-check">
                        <label className="form-check-label">
                            isAgency </label>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            name="isagency"
                            value={formik.values.isagency}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />

                    </div>
                    {formik.values.isagency && (
                        <div className="mb-3 ">
                            <label className="col-sm-2 col-form-label">
                                {" "}
                                Commission(%){" "}<span className="text-red-600">*</span>
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Commission"
                                aria-label=""
                                name="commission"
                                value={formik.values.commission}
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                }}
                            />
                            {submit && formik.errors.commission ? (
                                <div className="text-red-600	">{formik.errors.commission}</div>
                            ) : null}
                        </div>
                    )}

                    {flag === "edit" && (
                        <div className="mb-3 form-check form-switch">
                            <label className="form-check-label">
                                Status ({formik.values.status ? "Active" : "Inactive"})
                            </label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked={formik.values.status}
                                onChange={() => {
                                    formik.setFieldValue("status", formik.values.status ? 0 : 1);
                                }}
                            />
                        </div>
                    )}

                    <div slot="footer">
                        <SlButton
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={(e) => setSubmit(true)}>Submit</SlButton>
                    </div>
                </form>
            </SlDrawer>

            <SlDrawer label="Assign Sales Person" open={open} onSlAfterHide={handle} >
                <selectForm.Select
                    aria-label="Select Sales Person"
                    className="form-control mb-2"
                    value={sales_id}
                    onChange={(e) => {
                        setSalesId(e.target.value);
                    }}
                >
                    <option value="-1" key="-1">
                        Assign Sales
                    </option>
                    {sales.map((item) => {
                        return (
                            <option value={item.value} key={item.value}>
                                {item.label}
                            </option>
                        );
                    })}
                </selectForm.Select>
                <SlButton type="reset" variant="primary" onClick={handleSalesSave}>
                    Submit
                </SlButton>
            </SlDrawer>


            {/* <SlDrawer label="Add Advertiser Type" open={view} onSlAfterHide={handle} >
                <div className="mb-3">
                    <label className="mb-1">Advertise Type <span className="text-red-600">*</span></label>
                    <form class="inline-validation">
                        <input
                            className="form-control"
                            placeholder="Enter Advertiser Type"
                            name="adv_name"
                            onChange={handleInputChange}
                        /><br />
                        <SlButton type="reset" variant="primary" onClick={handleAdvType}>
                            Submit
                        </SlButton>
                    </form>
                </div>
            </SlDrawer> */}


            {/* <Modal show={view} onHide={handle}> 
        <Modal.Header closeButton>
          <Modal.Title>Add Advertiser Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Advertiser Type"
            aria-label=""
            name="adv_name"
            onChange={(e) => {
              setAdvType(e.target.value);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handle}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAdvType}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal> */}

            <Modal show={display} onHide={handle}>
                <Modal.Header closeButton>
                    <Modal.Title>Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        <div className="overflow-x-auto">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">State</th>
                                        <th scope="col"> District</th>
                                        <th scope="col">Mandal</th>
                                        <th scope="col">Village</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{res.state_name || "-"}</td>
                                        <td>{res.district_name || "-"}</td>
                                        <td>{res.mandal_name || "-"}</td>
                                        <td>{res.village_name || "-"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handle}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className="overflow-x-auto mb-4">
                <ScrollContainer>
                    <table className='table table-bordered '>
                        <thead className="sticky top-0  ">
                            <tr>
                                <th >Company ID</th>
                                <th >Company Name</th>
                                <th>Verified Status</th>
                                <th >Billing Name</th>
                                <th >Billing Email</th>
                                <th >Billing Mobile</th>
                                <th >GST No</th>
                                <th >PAN No</th>
                                {/* <th >Company Name</th> */}
                                <th >Location</th>
                                <th >Address</th>
                                {/* <th >Category </th> */}
                                <th >IsAgency</th>
                                <th >Commission(%)</th>
                                <th >Reg Date</th>
                                {/* <th >Upd Date</th> */}
                                <th >Status</th>
                                <th >Created By</th>
                                {/* <th >Assigned To</th> */}
                                <th >Actions</th>
                            </tr>
                        </thead>
                        {data?.length && !loader ? (
                            <tbody>
                                {data.map((item) => {
                                    return (
                                        <tr key={item.company_id} className="group/details hover:bg-slate-100">
                                            <th scope="row" className="flex items-center justify-center text-center gap-2">
                                                {item?.mc_actions?.length ?<button className="h-2 w-2 px-1 py-1 rounded-full bg-orange-300" title={`pending edit action by ${item?.mc_actions?.[0]?.mc_user_name}`} onClick={() => setSelectedMcId(item?.mc_actions?.[0]?.mc_id)}></button>: null}
                                                <span>{item.company_id}</span>
                                            </th>
                                            <td className={
                                                localStorage.getItem("role") === roles.financer &&
                                                "company-name"
                                                }
                                                onClick={() => {
                                                if (
                                                    localStorage.getItem("role") === roles.financer
                                                ) {
                                                    setCompanyId(item.id);
                                                    setShowCompany(true);
                                                }
                                                }}>{item.company_name}</td>
                                            <td
                                               
                                                >
                                                    <div  className={
                                                    item.verified_status == 1 ? "full-badge text-center" : 
                                                    item.verified_status ===2 ? "pending-badge text-center" :"unpaid-badge text-center"
                                                }>
                                                    {
                                                    item.verified_status === 1 ?
                                                    <span>
                                                    Verified{" "}
                                                    <sl-icon name="patch-check-fill"></sl-icon>
                                                    </span> :  item.verified_status === 2 ? <span>
                                                    Not Verified{" "}
                                                    <sl-icon name="x-circle-fill"></sl-icon> </span> :
                                                    <span>
                                                    Rejected{" "}
                                                    <sl-icon name="patch-check-fill"></sl-icon>
                                                    </span>

                                                }
                                                    </div>
                                                
                                            </td>
                                            <td>{item.billing_name}</td>
                                            <td>{item.billing_email || "-"}</td>
                                            <td>{item.billing_mobile}</td>
                                            <td>{item.gst_no || "-"}</td>
                                            <td>{item.pan_no || "-"}</td>
                                            {/* <td>{item.company_name}</td> */}
                                            <td>
                                                <sl-tooltip content="View location">
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="view"
                                                        onClick={() => {
                                                            handleLocation(item);
                                                        }}></sl-icon-button>
                                                </sl-tooltip>
                                                {/* <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          handleLocation(item);
                        }}
                      >
                        View
                      </button> */}
                                            </td>
                                            <td style={{"whiteSpace": "break-spaces"}}>{item.address || "-"}</td>
                                            {/* <td>{item.category_name || "-"}</td> */}
                                            <td>{item.isagency ? "YES" : "NO"}</td>
                                            <td>{item.commission || "-"}</td>
                                            <td>{formatDateWithTime(item.reg_date)}</td>
                                            {/* <td>{formatDateWithTime(item.upd_date)}</td> */}
                                            <td>
                                                <span className={item.status ? "full-badge text-center" : "unpaid-badge text-center"}>
                                                    {item.status ? "Active" : "Inactive"}
                                                </span>
                                            </td>
                                            <td>{item.user_name || "-"}</td>
                                            {/* <td>
                                                {item.name || (
                                                    <sl-tooltip content="Assign SalesPerson">
                                                        <sl-icon-button
                                                            library="lucide"
                                                            name="user-plus"
                                                            onClick={() => {
                                                                loadSales();
                                                                handleSales();
                                                                setId(item.id);
                                                            }}></sl-icon-button>
                                                    </sl-tooltip>
                                                )}
                                            </td> */}
                                            <td className="">
                                                <sl-tooltip content="Edit">
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="edit"
                                                        onClick={() => {
                                                            handleShow("edit", item);
                                                            setFlag("edit");
                                                            setId(item.id);
                                                        }}></sl-icon-button>
                                                </sl-tooltip>
                                                <sl-tooltip content="Logs">
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="terminal-square"
                                                        onClick={() => {
                                                            getLogs({id: item.id, company_name: item.company_name})
                                                        }}></sl-icon-button>
                                                </sl-tooltip>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : !data?.length && !loader ? (
                            <NoDataFound colspan="17" />
                        ) : (
                            <TableLoader colspan="17" />
                        )}
                    </table>
                </ScrollContainer>
            </div>
            <div className="flex justify-end">
                {totalPages > 1 && (
                    <Paginator
                        pageCount={totalPages}
                        handlePageClick={handlePageClick}
                        forcePage={currentPage}
                    />
                )}</div>

            {showCompany && (
                <CompanyDetails
                    company_id={companyId}
                    show={showCompany}
                    setShow={setShowCompany}
                    refresh={refresh}
                    setRefresh={setRefresh}
                />
            )}
            {Object.keys(logs)?.length ?  <SlDrawer
                label={`Update Logs of ${logs.company_name}`}
                style={{  '--size': `${window.innerWidth <= 767 ? '100vw' : '50vw' }` }}
                open={Object.keys(logs)?.length}
                onSlAfterHide={() => { setLogs({}); }}
            >
                <div className="overflow-x-auto">
                    <table className="table table-bordered compLogs">
                        <thead>
                            <tr>
                                <th className="row-span-2">Name</th>
                                <th  className="row-span-2">User Type</th>
                                <th  className="row-span-2">Time</th>
                                <th className="splThead">
                                    <table>
                                        <tr>
                                            <th colspan="3">Details</th>
                                        </tr>
                                        <tr>
                                            <th>Type</th>
                                            <th>Previous</th>
                                            <th>Updated</th>
                                        </tr>
                                    </table>
                                </th>                                
                            </tr>
                        </thead>
                        {Object.keys(logs)?.length ? <tbody>
                            {logs?.logs?.map((item) => {
                                return (
                                    <tr className={`row-span-${item.update.length}`}>
                                        <td>{capitalizeFirstLetter(item.user_name)}</td>
                                        <td>{item.user_type}</td>
                                        <td>{formatDateWithTime(item.time)}</td>
                                        <td colspan="3" className="splTdata">
                                            <table>
                                            {item.update.map(upItem => {
                                            return(<tr>
                                                <td>{upItem.changeType}</td>
                                                <td>{upItem.previous || "-"}</td>
                                                <td>{upItem.updated || "-"}</td>
                                                </tr>)
                                            })}
                                            </table>
                                            </td>                                        
                                    </tr>
                                )
                            })}
                        </tbody> : <NoDataFound></NoDataFound>}
                    </table>
                </div>
            </SlDrawer> : null }
            <PendingRequestModal mc_id={selectedMcId} isOpen={!!selectedMcId} onClose={handleCloseModal} />
        </div>
    );
}

export default Company;
